import LotsContainer from './lots-container';

export default LotsContainer;
